import { createContext, useContext, useMemo } from 'react';
import useFetchData from '../../app/api/hooks/useFetchData';
import { Endpoints } from '../../app/api/model/API.endpoints';
import { LocationsResponseDto } from './Location.model';
import { useAuth } from '../auth/providers/AuthProvider';

interface LocationContextValue {
  locations: LocationsResponseDto['content'] | undefined;
  isError: boolean;
}

const LocationContext = createContext<LocationContextValue | null>(null);

export const LocationProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { isAuthenticated } = useAuth();

  const { data: locationsResponse, error } = useFetchData<LocationsResponseDto['content']>({
    endpoint: Endpoints.LOCATIONS,
    options: { enabled: isAuthenticated, retry: 3 },
    includeContext: false,
  });

  const value = useMemo(
    () => ({ locations: locationsResponse?.content, isError: !!error }),
    [locationsResponse, error]
  );

  return <LocationContext.Provider value={value}>{children}</LocationContext.Provider>;
};

export const useLocations = () => {
  const ctx = useContext(LocationContext);

  if (!ctx) throw new Error('useLocation must be used within AuthProvider');
  return ctx;
};
